import { COVERGO_SAAS_DEV, COVERGO_EU_UAT, COVERGO_ASIA_QA } from "../consts.js"

export const santevet_dev = {
	"santevet-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "santevet_dev",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_SAAS_DEV
	}
}

export const santevet_uat = {
	"santevet-studio.uat.eu.covergo.cloud": {
		appConfig: {
			tenantId: "santevet_uat",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_EU_UAT,
		fileSystem: {
			bucketName: "covergo-euce1-uat-santevet-uat"
		}
	},
}

export const santevet_qa = {
	"santevet-studio.qa.asia.covergo.cloud": {
		appConfig: {
			tenantId: "santevet_qa",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_ASIA_QA,
		fileSystem: {
			bucketName: "covergo-apse1-qa-santevet-qa",
		},
	},
}
